import PropTypes from 'prop-types';
import React from "react";
import mercadoPagoSvg from "../../images/mercado-pago.svg";
import { LoaderSection } from "../elements/LoaderSection";


// AGUS - DESACTIVAR PROMOCION

export default class CalculatorResult extends React.Component {
    TODAY = new Date();

    INSTALLMENTS_INTEREST_RATES_FOOT_NOTES = {
        4: 'TNA: 58.02% - TEA: 74.90% - CTF: 78.65%\nCuotas mensuales fijas',
        5: 'TNA: 43.26% - TEA: 52.09% - CTF: 55.09%\nCuotas mensuales fijas',
        6: 'TNA: 28% - TEA: 31.48% - CTF: 34.98%\nCuotas mensuales fijas',
    }

    advancePayment() {
        return Math.round(this.props.amountInAdvance || 0);
    }

    feesAmount() {
        return this.props.feesAmount
    }

    renderInstallmentsAdvancePayment() {
        const isOnePayment = this.props.feesQuantity < 3;
        const isTwelvePayment = this.props.feesQuantity === 12;
        const isThreePayments = this.props.feesQuantity === 3;
        return (
            <div className="advance-payment-container">
                {isOnePayment ? (
                    <p className="advance-payment-text">
                        <span className="highlight-numbers" style={{ fontSize: '1em' }}>1</span> <span style={{ color: 'white', marginLeft: '5px', fontSize: '13.5px' }}>pago</span>
                    </p>
                ) : isThreePayments ? (
                    <p className="advance-payment-text">1ra cuota</p>
                ) : isTwelvePayment ? (
                    <p className="advance-payment-text">
                        <span className="highlight-numbers" style={{ fontSize: '1em' }}>12</span> <span style={{ color: 'white', marginLeft: '5px', fontSize: '13.5px' }}>cuotas de</span>
                    </p>
                ): (
                    <p className="advance-payment-text">Anticipo</p>
                )}
                <br />
                <p className="advance-payment-amount">${this.advancePayment().toLocaleString()}</p>
            </div>
        );
    }

    _renderTotalFee(totalAmount, cssClass, itsFinanced = false) {
        const title = itsFinanced ? 'Costo Total del servicio financiado' : 'Total costo por servicio'
        const finalAmount = totalAmount || 0;
        const formattedAmount = (finalAmount !== undefined && finalAmount !== null) ? finalAmount.toLocaleString() : '0';
        return <div className={cssClass}>
            <p>{title}:</p>
            <p>${formattedAmount}</p>
        </div>
    }

    renderFeesPayment(feesQuantity, feesAmount) {
        const amount = feesAmount || 0;
        return <div className="amount-paids">
            <div className="paid-number">
                <p className="highlight-numbers">{feesQuantity}</p>
                <p>cuotas de</p>
            </div>
            <p className="highlight-numbers total">${amount.toLocaleString()}</p>
        </div>;
    }

    // Interest-free installments
    _isInterestFreeInstallmentSelected() {
        return this.props.feesQuantity === 3 || this.props.feesQuantity === 12;
    }

    // Cash selected
    _isCashPaymentSelected() {
        return this.props.feesQuantity === 1;
    }

    _isTwelveInstallmentPaymentSelected() {
        return this.props.feesQuantity === 12;
    }

    renderCashTotal() {
        const totalFeeAmountWithoutDiscounts = this.props.totalFeeAmountWithoutDiscounts || 0;
        const discountPercentage = this.props.discountPercentage || 0;
        const discountFee = this.props.discountFee || 0;
        return (
            <div className="total-paid mercadopago-total-footer">
                <div className="amount-paids">
                    <div className="paid-number">
                        <p>Costo original del Servicio</p>
                    </div>
                    <p className="total">${totalFeeAmountWithoutDiscounts.toLocaleString()}</p>
                </div>
                <div className="amount-paids">
                    <div className="paid-number">
                        <p> Descuento {discountPercentage.toLocaleString()}%</p>
                    </div>
                    <p className="total">-${discountFee.toLocaleString()}</p>
                </div>
                {this._renderTotalFee(this.totalAmountForCashPayment(), "amount-paids")}
            </div>
        );
    }

    renderInstallmentsTotal() {
        return (
            <div className="total-paid mercadopago-total-footer">
                {/* <div className="amount-paids">
                    <div className="paid-number">
                        <p>Costo original del Servicio</p>
                    </div>
                    <p className="total">${this.props.totalFeeAmountWithoutDiscounts.toLocaleString()}</p>
                </div>
                <div className="amount-paids">
                    <div className="paid-number">
                        <p> Descuento aplicado (10%)</p>
                    </div>
                    <p className="total">-${this.props.discountFee.toLocaleString()}</p>
                </div> */}
                {this._renderTotalFee(this.props.totalAmount, "amount-paids")}
            </div>
        );
    }

    renderCashPayment(amount, isACashPayment = true) {
        const value = amount || 0;
        return <React.Fragment>
            <div className="amount-paids">
                <div className="paid-number">
                    <p className="highlight-numbers">1</p>
                    <p>pago</p>
                </div>
                <p className="highlight-numbers total">${value.toLocaleString()}</p>
            </div>
            {isACashPayment ?
                <div className="amount-paids">
                    <p className="discount-note-text"> (con {this.props.discountPercentage}% de descuento incluído)</p>
                </div>
                :
                <div></div>
            }
        </React.Fragment>
    }

    totalAmountForCashPayment() {
        let total = this.props.totalAmount;
        return Math.round(total);
    }

    // Render Box

    _installmentCalculatorBox(label, title, subtitle, footNote) {
        if (!this.isFeesAmountPermitted()) {
            return null
        }
        const renderAdvancePayment = this.renderInstallmentsAdvancePayment();
        const renderFees = this.renderFeesPayment(this.props.feesQuantity - 1, this.feesAmount());
        const renderTotal = this._renderTotalFee(this.props.totalAmount, "total-paid");

        const renderPromotion = this.props.feesQuantity >= 6 ? this._promotionValidityText() : null;
        return this._calculatorBox(label, title, subtitle, renderFees, renderTotal, footNote, renderAdvancePayment, renderPromotion);
    }

    _installmentsCalculatorBox() {
        const title = this.props.feesQuantity > 6 ? `${this.props.feesQuantity} cuotas` : `Hasta ${this.props.feesQuantity} cuotas`;
        const className = this.props.feesQuantity > 6 ? "twelve-label" : "mp-label";
        const footNote = this._feesQuantityFootNote();
        return this._installmentCalculatorBox(className, title, '', footNote);
    }

    _feesQuantityFootNote() {
        const defaultFeesAmount = this.feesAmount() === 0;
        const feesQuantity = this.props.feesQuantity;
        return defaultFeesAmount ? '' : this.INSTALLMENTS_INTEREST_RATES_FOOT_NOTES[feesQuantity];
    }

    _interestFreeInstallmentsCalculatorBox() {
        if (!this.isFeesAmountPermitted()) {
            return null
        }
        
        const title = ``;
        const subtitle = `3 cuotas sin interés`;
        const renderAdvancePayment = this.renderInstallmentsAdvancePayment();
        const renderFees = this.renderFeesPayment(this.props.feesQuantity - 1, this.feesAmount());
        const renderTotal = this.renderInstallmentsTotal();

        return this._calculatorBox("installment-label", title, subtitle, renderFees, renderTotal, '', renderAdvancePayment);
    }

    _twelveInstallmentsCalculatorBox() {
        if (!this.isFeesAmountPermitted()) {
            return null;
        }
        let title = ``;
        let subtitle = `12 cuotas sin interés`;
        const renderFees = this.renderFeesPayment(this.props.feesQuantity, this.feesAmount());
        let renderTotal = this.renderInstallmentsTotal();
        return this._calculatorBox("twelve-label", title, subtitle, renderFees, renderTotal, undefined, undefined, this._promotionValidityText());
    }

    _cashCalculatorBox() {
        let title = `${this.props.discountPercentage}% OFF `;
        let subtitle = `Pago de contado`;
        let renderFees = this.renderCashPayment(this.totalAmountForCashPayment(), true);
        let renderTotal = this.renderCashTotal();
        let renderPromotion = this.cashPaymentFootNoteOneInstallmentPayment();
        return this._calculatorBox("cash-label", title, subtitle, renderFees, renderTotal, undefined, undefined, renderPromotion);
    }

    _getPromotionalText(day, month, year) {
        return `Promoción válida hasta el ${day}/${month}/${year}`;
    }

    _promotionValidityText() {
        const today = this.TODAY.getDate();
        const month = this.TODAY.getMonth() + 1;
        const year = this.TODAY.getFullYear();
        const day = today <= 15 ? 15 : new Date(year, this.TODAY.getMonth() + 1, 0).getDate();
        return this._getPromotionalText(day, month, year);
    }

    cashPaymentFootNoteOneInstallmentPayment() {
        const day = this.TODAY.getDate();
        const month = this.TODAY.getMonth() + 1;
        const year = this.TODAY.getFullYear();
        return this._getPromotionalText(day, month, year);
    }

    cashPaymentFootNoteMultipleInstallmentsPayment() {
        const lastDay = new Date(this.TODAY.getFullYear(), this.TODAY.getMonth() + 1, 0).getDate();
        const month = this.TODAY.getMonth() + 1;
        const year = this.TODAY.getFullYear();
        return this._getPromotionalText(lastDay, month, year);
    }
    renderLoadingBox() {
        return (
            <div className="information-paids-box  col m6 col s12">
                <LoaderSection />
            </div>
        )
    }

    isFeesAmountPermitted() {
        return this.props.isFeesAmountPermitted
    }

    renderBoxContent(renderFees, renderTotal, footNote, renderAdvancePayment, renderPromotion) {
        const isTwelveInstallment = this._isTwelveInstallmentPaymentSelected();
        return (
            <div className="information-paids-box col m6 col s12">
                {renderAdvancePayment}
                {renderFees}
                {renderTotal}
                {isTwelveInstallment && (
                    <div className="mercado-pago-promotion-container">
                        <img src={mercadoPagoSvg} alt="Mercado Pago" className="mercado-pago-promotion-logo" />
                    </div>
                )}
                <div className="calculator-footer">
                    {footNote}
                </div>
                <div className="calculator-promotion">
                    {renderPromotion}
                </div>
            </div>
        )
    }

    _calculatorBox(label, title, subtitle, renderFees, renderTotal, footNote = '', renderAdvancePayment = undefined, renderPromotion = undefined) {
        return (
            <div className={`calculator-control-result ${label}`}>
                <div className="calculator-control-header">
                    <div className="calculator-control-label">{title}</div>
                    <div className="calculator-control-subtitle">{subtitle}</div>
                </div>
                {this.props.loading ? this.renderLoadingBox() : this.renderBoxContent(renderFees, renderTotal, footNote, renderAdvancePayment, renderPromotion, renderPromotion)}
            </div>
        );
    }

    render() {
        if (this._isTwelveInstallmentPaymentSelected()) {
            return this._twelveInstallmentsCalculatorBox()
        }
        if (this._isInterestFreeInstallmentSelected()) {
            return this._interestFreeInstallmentsCalculatorBox();
        }
        if (this._isCashPaymentSelected()) {
            return this._cashCalculatorBox()
        }
        return this._installmentsCalculatorBox()
    }
}

CalculatorResult.propTypes = {
    mercadoPagoSurchargePercentage: PropTypes.number,
    loading: PropTypes.bool,
    discountPercentage: PropTypes.number,
    mercadoPagoDiscount: PropTypes.number,
    feesQuantity: PropTypes.number,
    totalAmount: PropTypes.number,
    feesAmount: PropTypes.number,
    amountInAdvance: PropTypes.number,
    totalFeeAmountWithoutDiscounts: PropTypes.number,
    discountFee: PropTypes.number,
    isFeesAmountPermitted: PropTypes.bool,
    cashPaymentAmount: PropTypes.number
}
